import { Modal, Text, Group, Button, ScrollArea } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks";

interface ConfirmationModalProps {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    text?: string;
    component?: React.ReactNode;
}

const ConfirmationModal = ({ opened, onClose, onConfirm, text, component }: ConfirmationModalProps) => {
    const isMobile = useMediaQuery('(max-width: 50em)');

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Confirmation"
            radius="md"
            size="lg"
            fullScreen={isMobile}
            transitionProps={{ transition: 'fade', duration: 200 }}
            scrollAreaComponent={ScrollArea.Autosize}
            removeScrollProps={{ allowPinchZoom: true }}
        >
            {text && <Text fw={500}>{text}</Text>}
            {component || null}
            <Group justify="flex-end" mt="md">
                <Button variant="outline" onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm}>Confirm</Button>
            </Group>
        </Modal>
    )
}

export default ConfirmationModal;